// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as NextImage$PorterinFeature from "../../../../../ui/components/NextImage.mjs";
import * as OrderReviewVm$PorterinFeature from "../../../view-model/OrderReviewVm.mjs";
import * as FareEstimateStore$PorterinFeature from "../../../../../shared/core/constants/FareEstimateStore.mjs";
import * as AutoCompleteNoPlacesCmpModuleScss from "../../styles/AutoCompleteNoPlacesCmp.module.scss";

var styles = AutoCompleteNoPlacesCmpModuleScss;

function AutoCompleteNoPlacesCmp(Props) {
  return React.createElement("div", {
              className: styles["search-results-empty"]
            }, React.createElement(NextImage$PorterinFeature.make, {
                  src: OrderReviewVm$PorterinFeature.search.src,
                  height: OrderReviewVm$PorterinFeature.search.height,
                  width: OrderReviewVm$PorterinFeature.search.width,
                  quality: 70.0,
                  alt: OrderReviewVm$PorterinFeature.search.alt
                }), React.createElement("div", {
                  className: styles["search-results-empty-title"]
                }, FareEstimateStore$PorterinFeature.search_results_empty_title), React.createElement("div", {
                  className: styles["search-results-empty-subtitle"]
                }, FareEstimateStore$PorterinFeature.search_results_empty_subtitle));
}

var make = AutoCompleteNoPlacesCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
